<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>

  <!-- Pre-split: selection grid -->
  <div *ngIf="!isSplitComplete" class="flex flex-col flex-1 min-h-0">
    <div class="flex justify-between items-center mb-4 shrink-0">
      <div class="h3 m-0">Item Details on Addon Bin: {{ addonBin.id }}</div>
      <div class="text-sm opacity-70">{{ selectedCount }} of {{ itemDetails.length }} selected</div>
    </div>
    <app-ag-grid class="flex-1 min-h-0" [gridOptions]="gridOptions" [rowData]="itemDetails"></app-ag-grid>
  </div>

  <!-- Post-split: print panel -->
  <div *ngIf="isSplitComplete" class="flex flex-col flex-1 min-h-0 p-4">
    <div class="flex flex-col items-center gap-6 mt-8">
      <div class="text-center">
        <div class="text-lg opacity-70 mb-2">Split Complete</div>
        <div class="text-4xl font-bold">New Bin: {{ newAddonBin.id }}</div>
        <div class="text-sm opacity-70 mt-2">{{ splitItemDetails.length }} item(s) moved to new bin</div>
      </div>
      <div class="flex gap-4 mt-4">
        <button pButton type="button" class="p-button-raised"
          icon="pi pi-print" (click)="printBinLabel()">
          <span>Print Bin Label</span>
        </button>
        <button pButton type="button" class="p-button-raised p-button-outlined"
          icon="pi pi-print" (click)="printRevisedItemLabels()">
          <span>Print Revised Item Labels</span>
        </button>
      </div>
    </div>
  </div>

</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <!-- Pre-split buttons -->
    <button *ngIf="!isSplitComplete && isPageReady" (click)="ok()"
      pButton type="button" class="p-button-raised">
      Ok
    </button>
    <button *ngIf="!isSplitComplete" (click)="cancel()"
      pButton type="button" class="p-button-raised">
      Cancel
    </button>
    <!-- Post-split button -->
    <button *ngIf="isSplitComplete" (click)="close()"
      pButton type="button" class="p-button-raised">
      Close
    </button>
  </div>
</ng-template>
